import React, { useMemo } from "react";
import { Box, Card, CardContent, Grid, Stack, Typography } from "@mui/material";
import FunnelStageCard from "./FunnelStageCard";
import { FUNNEL_STAGES, TRANSVERSAL_STAGE, isStageConfigured } from "./funnelStages";

function pickStageMetrics(metrics, stageId) {
  const m = metrics && typeof metrics === "object" ? metrics : {};
  const stages = m.stages && typeof m.stages === "object" ? m.stages : {};
  const s = stages[stageId] && typeof stages[stageId] === "object" ? stages[stageId] : {};
  return {
    volume: s.volume ?? null,
    conversionRate: s.conversionRate ?? null,
  };
}

export default function CampaignFunnelView({ flowConfig, metrics, onOpenStage }) {
  const configuredByStage = useMemo(() => {
    const out = {};
    for (const s of FUNNEL_STAGES) out[s.id] = isStageConfigured(flowConfig, s.id);
    out[TRANSVERSAL_STAGE.id] = isStageConfigured(flowConfig, TRANSVERSAL_STAGE.id);
    return out;
  }, [flowConfig]);

  return (
    <Box>
      <Card variant="outlined" sx={{ mb: 2 }}>
        <CardContent>
          <Stack direction={{ xs: "column", md: "row" }} spacing={2} alignItems={{ md: "center" }} justifyContent="space-between">
            <Box>
              <Typography fontWeight={900}>Funil da campanha</Typography>
              <Typography variant="body2" color="text.secondary">
                Configure por etapa. A recuperação aparece como camada transversal.
              </Typography>
            </Box>
            <Box>
              <Typography variant="body2" color="text.secondary">
                Dica: clique em uma etapa para configurar.
              </Typography>
            </Box>
          </Stack>
        </CardContent>
      </Card>

      <Grid container spacing={2}>
        {FUNNEL_STAGES.map((s) => {
          const sm = pickStageMetrics(metrics, s.id);
          return (
            <Grid key={s.id} item xs={12} md={6} lg={4}>
              <FunnelStageCard
                label={s.label}
                configured={!!configuredByStage[s.id]}
                volume={sm.volume}
                conversionRate={sm.conversionRate}
                onClick={() => onOpenStage?.(s.id)}
              />
            </Grid>
          );
        })}

        <Grid item xs={12}>
          <Card variant="outlined" sx={{ borderStyle: "dashed" }}>
            <CardContent>
              <Stack direction={{ xs: "column", md: "row" }} spacing={2} alignItems={{ md: "center" }} justifyContent="space-between">
                <Box>
                  <Typography fontWeight={900}>{TRANSVERSAL_STAGE.label} (transversal)</Typography>
                  <Typography variant="body2" color="text.secondary">
                    Reengajamento e recuperação: email, remarketing, follow-up e retomada de conversas.
                  </Typography>
                </Box>
                <FunnelStageCard
                  label="Recuperação"
                  configured={!!configuredByStage[TRANSVERSAL_STAGE.id]}
                  volume={pickStageMetrics(metrics, TRANSVERSAL_STAGE.id).volume}
                  conversionRate={pickStageMetrics(metrics, TRANSVERSAL_STAGE.id).conversionRate}
                  onClick={() => onOpenStage?.(TRANSVERSAL_STAGE.id)}
                />
              </Stack>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
}

